module.exports = __webpack_public_path__ + "img/左右翻转-角标3.8e926395.svg";